export default "__VITE_ASSET__CGsowDGu__"